import React from 'react'; 
import {motion} from "framer-motion";
import { useVisualContext } from "Contexts/VisualContext";

const InfoContentMotionWrapper = ({
  className,
  children,
  ...props
})=>{

  const {transitionState} = useVisualContext();

  const variants = {
    initial: {
      opacity: 0,
      y: 100,
    },
    in: {
      opacity: 1,
      y: 0,
    }, 
    out: {
      opacity: 0,
      y: -100,
    }
  }

  return(
    <motion.div
      className={{className}}
      initial={"initial"}
      animate={transitionState === "transitionOut" ? "out" : "in"}
      variants={variants}
      transition={{ 
        type: "spring", 
        ease: "easeOut", 
        duration: 0.8, 
        bounce: 0.5,
      }}
      >
      {children}
    </motion.div>
  )
}

export default InfoContentMotionWrapper;